<script lang="ts">
import { defineComponent, h, ref } from 'vue';

import { classNames } from '@components/utils';

import {
  makeDisabledProps,
  makeGroupItemProps,
  makeIconProps,
  makeLoadingProps,
  makeReadonlyProps,
  makeTextProps,
  useRender
} from '../../composable';
import { CdsTab } from '../CdsTabs';

export const componentName = 'CdsContentSwitcherItem';
export default defineComponent({
  name: componentName,
  props: {
    ...makeGroupItemProps(),
    ...makeDisabledProps(),
    ...makeReadonlyProps(),
    ...makeLoadingProps(),
    ...makeIconProps(),
    ...makeTextProps()
  },
  emits: {},
  setup(props, { slots }) {
    const tabRef = ref<typeof CdsTab>();

    useRender(() =>
      h(
        CdsTab,
        {
          ref: tabRef,
          readonly: props.readonly,
          disabled: props.disabled,
          prependIcon: props.prependIcon,
          appendIcon: props.appendIcon,
          loading: props.loading,
          value: props.value,
          tabindex: 0,
          selectedClass: classNames('cds-content-switcher__item--selected', props.selectedClass),
          class: 'cds-tab cds-content-switcher__item'
        },
        {
          default: () => slots.default?.() ?? props.text,
          ...(slots.prepend ? { prepend: () => slots.prepend?.() } : {}),
          ...(slots.append ? { append: () => slots.append?.() } : {})
        }
      )
    );

    return {
      tabRef
    };
  }
});
</script>
